// ─────────────────────────────────────────────────────────────────────────────
// JW Player configuration
//
// To turn JW Player ON, paste your cloud-hosted library URL below. You get it
// from the JW Player dashboard: Players → (your player) → the "cloud-hosted"
// script link, which looks like:
//
//   https://cdn.jwplayer.com/libraries/XXXXXXXX.js
//
// The license key is baked into that library, so nothing else is required.
//
// If you self-host instead, set JW_PLAYER_SCRIPT_URL to your jwplayer.js path
// and JW_PLAYER_LICENSE_KEY to your key string.
//
// While JW_PLAYER_LIBRARY_URL (or the self-hosted pair) is empty, the app keeps
// using the existing hls.js / native player — so this is safe to ship as-is and
// flip on the moment you add your key.
// ─────────────────────────────────────────────────────────────────────────────

export const JW_PLAYER_LIBRARY_URL = '';

// Self-hosted fallback (leave empty when using the cloud library above).
export const JW_PLAYER_SCRIPT_URL = '';
export const JW_PLAYER_LICENSE_KEY = '';

export const isJWConfigured = () => Boolean(JW_PLAYER_LIBRARY_URL || JW_PLAYER_SCRIPT_URL);
